
import toast from 'react-hot-toast';


export const notify = (message: string, type: string = "") => {
  if (message) {
    type == "success" ? toast.success(message ) :
    toast.error(message );
  }
}